document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Product photo zoom: magnifying-glass hover effect ---------- */
  var zoomContainer = document.querySelector('.product-gallery__main');
  if (zoomContainer) {
    var zoomImg = zoomContainer.querySelector('img');
    if (zoomImg) {
      zoomContainer.addEventListener('mousemove', function (e) {
        var rect = zoomContainer.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        zoomImg.style.transformOrigin = x + '% ' + y + '%';
        zoomContainer.classList.add('is-zoomed');
      });
      zoomContainer.addEventListener('mouseleave', function () {
        zoomContainer.classList.remove('is-zoomed');
        zoomImg.style.transformOrigin = 'center center';
      });
    }
  }

  /* ---------- Product gallery: click thumbnail to swap main image (and match its color) ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (main && thumb.dataset.fullSrc) {
          main.src = thumb.dataset.fullSrc;
        }
        if (thumb.dataset.swatchColor) {
          var matchingSwatch = document.querySelector('[data-swatch-group] [data-swatch="' + thumb.dataset.swatchColor + '"]');
          if (matchingSwatch && !matchingSwatch.classList.contains('is-selected')) {
            matchingSwatch.click();
          }
        }
      });
    });
  });

  /* ---------- Variant picker: resolve the correct variant as options change ---------- */
  document.querySelectorAll('#ProductForm').forEach(function (form) {
    var variantsScript = document.querySelector('[data-product-variants]');
    if (!variantsScript) return;

    var variants;
    try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-variant-id-input]');
    var addBtn = form.querySelector('[data-add-to-cart-btn]');
    var addBtnText = form.querySelector('[data-add-to-cart-text]');
    var mainImage = document.querySelector('[data-gallery-main]');

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function getSelectedOptions() {
      var selected = [];
      form.querySelectorAll('[data-swatch-group]').forEach(function (group) {
        var position = parseInt(group.dataset.optionPosition, 10);
        var active = group.querySelector('[data-swatch].is-selected') || group.querySelector('[data-swatch]');
        if (active) selected[position - 1] = active.dataset.swatch;
      });
      form.querySelectorAll('[data-option-select]').forEach(function (select) {
        var position = parseInt(select.dataset.optionPosition, 10);
        selected[position - 1] = select.value;
      });
      return selected;
    }

    function findVariant(selected) {
      return variants.find(function (v) {
        return [v.option1, v.option2, v.option3].every(function (opt, i) {
          return selected[i] === undefined || opt === selected[i];
        });
      });
    }

    function updateForSelection() {
      var variant = findVariant(getSelectedOptions());

      if (!variant) {
        if (idInput) idInput.value = '';
        if (addBtn) addBtn.disabled = true;
        if (addBtnText) addBtnText.textContent = 'Unavailable';
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (addBtn) addBtn.disabled = !variant.available;
      if (addBtnText) {
        addBtnText.textContent = variant.available
          ? 'Add to Cart — ' + formatMoney(variant.price)
          : 'Sold Out';
      }
      if (mainImage && variant.featured_image && variant.featured_image.src) {
        mainImage.src = variant.featured_image.src;
      }
    }

    form.querySelectorAll('[data-swatch-group] [data-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var group = swatch.closest('[data-swatch-group]');
        group.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-selected'); });
        swatch.classList.add('is-selected');
        updateForSelection();
      });
    });

    form.querySelectorAll('[data-option-select]').forEach(function (select) {
      select.addEventListener('change', updateForSelection);
    });

    updateForSelection();
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- Cart line quantity change: submit cart form ---------- */
  document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------- Header nav dropdown: JS-driven open/close so it doesn't
     get closed by browsers re-checking :hover during scroll ---------- */
  document.querySelectorAll('[data-nav-dropdown]').forEach(function (wrap) {
    var closeTimer = null;

    function open() {
      clearTimeout(closeTimer);
      wrap.classList.add('is-open');
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        wrap.classList.remove('is-open');
      }, 200);
    }

    wrap.addEventListener('mouseenter', open);
    wrap.addEventListener('mouseleave', scheduleClose);
    wrap.addEventListener('focusin', open);
    wrap.addEventListener('focusout', function (e) {
      if (!wrap.contains(e.relatedTarget)) scheduleClose();
    });
  });

  /* ---------- Hero carousel: auto-rotate through the featured collection's products ---------- */
  document.querySelectorAll('[data-hero-carousel]').forEach(function (carousel) {
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-hero-slide]'));
    if (slides.length < 2) return;

    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'hero__carousel-dots';
    dotsWrap.setAttribute('data-hero-dots', '');
    var dots = slides.map(function (_, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'hero__carousel-dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('data-hero-dot', '');
      dot.setAttribute('aria-label', 'Show slide ' + (i + 1));
      dotsWrap.appendChild(dot);
      return dot;
    });
    carousel.appendChild(dotsWrap);
    var delay = parseInt(carousel.dataset.autoplay, 10) || 4000;
    var current = 0;
    var timer = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      slides[current].setAttribute('tabindex', '-1');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
      slides[current].removeAttribute('tabindex');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function start() {
      if (reduceMotion) return;
      stop();
      timer = setInterval(function () { goTo(current + 1); }, delay);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        start();
      });
    });

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', start);

    start();
  });

});
